<ng-container *ngIf="isReadMode; else writeMode">
<span>{{ inputValue }}</span>
</ng-container>
<ng-template #writeMode>
<mat-form-field appearance="outline" class="col-sm-12">
        <input matInput [formControl]="control" [matAutocomplete]="auto"
            [placeholder]="isFocused ? '' : (placeholder ?? ('COMMON_LABELS.SELECT_FROM_LIST_OR_ENTER_OTHER_HERE' | translate))"
            #trigger="matAutocompleteTrigger" (focus)="onFocus()" (blur)="onBlur()">
    <button matSuffix mat-icon-button type="button" tabindex="-1" (click)="onDropDownIconClick(trigger)" [disabled]="control.disabled">
        <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelection()">
    @for (option of filteredOptions; track option.value) {
        <mat-option class="optionHeight" [value]="option.label">{{ option.label }}</mat-option>
    }
    </mat-autocomplete>
</mat-form-field>
</ng-template>
